import React from 'react';
import { Box, Button, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SectionHeading from './SectionHeading';
import { services } from '../data/company';
import { brand } from '../theme';

const useStyles = makeStyles((theme) => ({
  section: {
    backgroundColor: '#FFFFFF',
    borderTop: `1px solid ${brand.line}`,
    borderBottom: `1px solid ${brand.line}`,
    padding: theme.spacing(12, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 0),
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '4fr 7fr',
      gap: theme.spacing(10),
    },
  },
  intro: {
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: 120,
      alignSelf: 'start',
    },
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    borderTop: `1px solid ${brand.ink}`,
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '56px 1fr',
    alignItems: 'baseline',
    padding: theme.spacing(3, 0),
    borderBottom: `1px solid ${brand.line}`,
    transition: 'background-color 200ms ease, padding 200ms ease',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '72px 220px 1fr',
    },
    '&:hover': {
      backgroundColor: brand.paper,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2.5, 0),
      '&:hover': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
  number: {
    fontSize: '0.8rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    color: brand.accent,
  },
  name: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(0.5),
    },
  },
  description: {
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('xs')]: {
      gridColumn: 2,
    },
  },
  cta: {
    marginTop: theme.spacing(2),
  },
}));

export default function Services() {
  const classes = useStyles();

  return (
    <Box component="section" id="services" className={classes.section}>
      <Container maxWidth="lg">
        <div className={classes.grid}>
          <div className={classes.intro}>
            <SectionHeading
              index="01"
              eyebrow="Services"
              title="Every trade your project needs."
              subtitle="From structure to finishes, we handle the whole project so you work with a single contractor from start to finish."
            />
            <Button
              href="#quote-form"
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              className={classes.cta}>
              Discuss your project
            </Button>
          </div>

          <ol className={classes.list}>
            {services.map(({ name, description }, index) => (
              <li key={name} className={classes.row}>
                <span className={classes.number}>{String(index + 1).padStart(2, '0')}</span>
                <Typography variant="h5" component="h3" className={classes.name}>
                  {name}
                </Typography>
                <Typography variant="body2" className={classes.description}>
                  {description}
                </Typography>
              </li>
            ))}
          </ol>
        </div>
      </Container>
    </Box>
  );
}
